import type { Content } from '@generalTypes/apiTypes';
import { nodeTypeConfigurations } from '.';
import type { NodeType } from './configTypes';
import { nodeTypeDefinitions } from './nodeTypeConfig';

export const getCreateDefaults = (nodeType: NodeType): Partial<Content> => {
  const { node } = nodeTypeDefinitions[nodeType];

  const config = nodeTypeConfigurations[nodeType];

  if ('createDefaults' in config) {
    return { ...node, ...config.createDefaults };
  }
  return node;
};
